import { type IdeasIdeaPortalAttributes } from './generated/IdeasIdeaPortalAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface IdeasIdeaPortal extends IdeasIdeaPortalAttributes {}

@model
class IdeasIdeaPortal extends ApplicationModel {
  // Start auto-generated
  static typename: 'IdeasIdeaPortal' = 'IdeasIdeaPortal';
  get typename(): 'IdeasIdeaPortal' {
    return 'IdeasIdeaPortal';
  }

  static fields = {
    id: attr({ readable: true }),
    title: attr({ readable: true }),
  };
  // End auto-generated
}

export default IdeasIdeaPortal;
